


import React, { useCallback, useContext, useEffect, useReducer, useState } from "react";
import {  useNavigate } from "react-router-dom";
import {  Nav, Tab } from "react-bootstrap";
import 'react-datepicker/dist/react-datepicker.css';


import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { getVendorByPropIdApi } from "../../../service/property/getVendorByProp";
import AssignUserModal from "./assignUserModal";
import UserTable from "./userTable";
import { getUserByPropIdApi } from "../../../service/property/getUserByPropId";
import { disassociatePropertyUserApi } from "../../../service/user/disassociatePropertyUser";
import { setLoading } from "../../../feature/authSlice";

const AssignUsers = () => {
  const {PropertyId,customerId} = useSelector(state => state.auth)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const[UserListArr,setUserListArr] = useState([])
  const[apiLoading,setApiLoading] = useState(false)
  const [pageViewUser, setPageViewUser] = useState(1);
  const [pageSizeViewUser, setPageSizeViewUser] = useState(10);
  const [totalPageViewUser, setTotalPageViewUser] = useState(1);
  const [searchValueViewUser, setSearchValueViewVendor] = useState("");
  const [totalViewVendorCount, setTotalViewVendorCount] = useState(0);

  const [selectedRows,setSelectedRows] = useState([])
  const handleSearchViewVendor = (e) => {
    // setPage(1)

    setSearchValueViewVendor(e.target.value);
    if (searchValueViewUser.trim().length >= 2) {
      onChangePageViewVendor(1);
    }
  };

  const handleChangeRowsPerPageViewVendor= (e) => {
    setSearchValueViewVendor("");
    setPageViewUser(1);
    setPageSizeViewUser(e.target.value);
  };

  const onChangePageViewVendor = (e, p) => {
    // setPage(p);
    setPageViewUser(e);
  };
 
  const columns = [
    {
      Header: " ",
      Footer: "",
      accessor: "sd",
    },
   
    {
      Header: "User Email ",
      Footer: "User Email ",
      accessor: "Email",
    },
   
    {
      Header: "User Phone",
      Footer: "User Phone",
      accessor: "Phone",
    },
    {
      Header: "Roles",
      Footer: "Roles",
      accessor: "Roles",
    }

  ];
const getUserData =async(val) =>{
  setSelectedRows([])
  
  setApiLoading(true)
    var data ={
        // propertyId:localStorage.getItem("propId")
        "Filter": "",
        "OrderBy": "",
        "PageSize": 0,
        "PageNumber": 0,
        "Keyword": searchValueViewUser,
        "PropertyId": localStorage.getItem("propId")
    }

    dispatch(getUserByPropIdApi(data,(res)=>{
        setApiLoading(false)
        
        setUserListArr(res.data.result.List)
    },(res)=>{
        setApiLoading(false)
        
    }))
}

  useEffect(()=>{
getUserData()
}, [pageViewUser, pageSizeViewUser, searchValueViewUser]); // Trigger fetch on search or pagination change

  const[assigningUserModalView,setAssigningUserModalView] = useState(false)
  function handleAssigingUserModal (){
    setAssigningUserModalView(!assigningUserModalView)
    if(assigningUserModalView){
      getUserData()
    }
  }
  const [addUserModalView,setAddUserModalView] = useState(false)

  function handleDisassociateUser(){
    
    var data ={
      UserIds: selectedRows.map((item)=>item.Id),
      PropertyId: localStorage.getItem("propId"),
    }
    dispatch(disassociatePropertyUserApi(data,(response)=>{
      if(response.data.statusCode===200){
      toast.success("User removed successfully")
      }
      // handleModalView()
                  getUserData()
      setApiLoading(false)
      

    },(res)=>{
      setApiLoading(false)
      
    }))
  }
  return (
    <>
      <ToastContainer />
      <div className="row d-flex justify-content-between">
        <div className="row">
        <div className="col-xxl-12">
          <div className="card">
          

            <Tab.Container defaultActiveKey="Pending">
              <div className="card-header border-0 pb-2 flex-wrap">
          <div className="d-flex">
          <i className="material-icons" style={{cursor:'pointer',marginRight:'10px',marginTop:'1px'}} onClick={()=>window.history.go(-1)}>chevron_left</i> 
          <h4 className="heading me-2">Assigned Users List</h4>
          </div>
             <div >

            {selectedRows.length > 0 && <button type="submit"style={{marginRight:'10px'}} className="btn btn-primary" onClick={handleDisassociateUser} >
             Remove User
                      </button>}
             <button type="submit" className="btn btn-primary" onClick={handleAssigingUserModal} >
                 Assign Users +
                      </button>
             </div>
               
              </div>
              <div className="card-body pt-2">

 <div style={{display:'flex',justifyContent:'start'}} >

           
               
              </div>
              <UserTable
                      column={columns}
                      rowsArr={UserListArr}
                 
            showLoading={apiLoading}
                
                   handleChangeRowsPerPagePagination={
                    handleChangeRowsPerPageViewVendor
                  }
                  searchValuePagination={searchValueViewUser}
                  pageSizePagination={pageSizeViewUser}
                  handleSearchPagination={handleSearchViewVendor}
                  totalCountPagination={totalPageViewUser}
                  handleOnChangePagination={onChangePageViewVendor}
                  totalCount={totalViewVendorCount}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                 
                    />
               
              </div>
            </Tab.Container>
          </div>
        </div>
      </div>
      </div>

{assigningUserModalView &&<AssignUserModal getUserData={getUserData} modalView={assigningUserModalView} handleModalView={handleAssigingUserModal}/>
    }
    </>
  );
};
export default AssignUsers;
